import { Link } from "react-router-dom";
import timeAgo from "../../helper/timeago";

const TicketDetail = ({ user, date, subject, message, admin_reply, contact, img }) => {
    return (
        <>
            <div className="flex flex-col gap-4 mb-6">
                <div className="flex items-center justify-between gap-3 px-4">
                    <div className="text-sm font-bold">{!!user ? ('فرستنده: ' + user.first_name + ' ' + user.last_name) : 'پیغام شما'}</div>
                    <div className="text-xs" dir="auto">{timeAgo(date)}</div>
                </div>
                <div className="flex flex-col gap-5 border p-4 rounded-lg">
                    {img &&
                        <div className="centerOfParent max-w-sm mx-auto overflow-hidden rounded-lg">
                            <Link to={img} target="_blank">
                                <img src={img}  width={100} height={100} className="w-full h-auto object-contain" />
                            </Link>
                        </div>
                    }
                    <div className="flex flex-col gap-1">
                        <span className="text-sm font-bold mr-3">عنوان:</span>
                        <div className="border-b p-3 text-sm max-h-[100px] overflow-y-auto w-fit">{subject}</div>
                    </div>
                    <div className="flex flex-col gap-1">
                        <span className="text-sm font-bold mr-3">متن پیام:</span>
                        <div className="border-b p-3 text-sm max-h-[200px] overflow-y-auto">{message}</div>
                    </div>
                    {contact && <div className="flex gap-1">
                        <span className="text-sm font-bold mr-3">تماس:</span>
                        <div className="text-sm">{contact}</div>
                    </div>}
                </div>
                {admin_reply && <div className="flex flex-col gap-1 border rounded-lg p-4">
                    <span className="text-sm font-bold mr-3">پاسخ ادمین:</span>
                    <div className="border-b p-3 text-sm max-h-[200px] overflow-y-auto">{admin_reply}</div>
                </div>}
            </div>
        </>
    );
};

export default TicketDetail;